import jQuery from 'jquery';
import Swal from 'sweetalert2';
import "@fortawesome/fontawesome-free";
import "bootstrap";
import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
  Thumbs,
} from "swiper";
import skrollr from "skrollr";
import AOS from "aos";
import "aos/dist/aos.css";
import lax from "lax.js"; 

window.$ = window.jQuery = jQuery;
window.Swal = Swal;
window.Swiper = Swiper;
window.Autoplay = Autoplay;
window.Navigation = Navigation;
window.Pagination = Pagination;
window.EffectFade = EffectFade;
window.Thumbs = Thumbs;
window.skrollr = skrollr;
window.Aos = AOS;
window.Lax = lax;